import { getMappedV3Data } from 'common/services/metrics.service';
import { getMetricsPerGranularityDataMapped } from '../GroupDashboard/groupDashboard.service';
import { shouldFetchTotalsFromBackend } from '../../performance/views/CustomReport/custom-report.util';

export const getMappedData = (
  aggregatedMetrics,
  metricsPerGranularity = [],
  teamId
) => {
  const v3DataResult = aggregatedMetrics?.[0]?.data?.[0] || {};
  const mappedV3Data = getMappedV3Data({ v3DataResult });

  const metricsPerGranularityCurrentGroup =
    metricsPerGranularity?.[0]?.data || [];
  const metricsPerGranularityMapped = getMetricsPerGranularityDataMapped(
    metricsPerGranularityCurrentGroup
  );

  return { mappedV3Data, metricsPerGranularityMapped };
};

export const getAggregatedMetrics = metrics => {
  return metrics.filter(metricName => {
    return shouldFetchTotalsFromBackend(metricName);
  });
};
